import styled from 'styled-components';

export { default as AsyncSelect } from '@bit/xseed.ui-components.async-select';
export { default as Button } from '@bit/xseed.ui-components.button';
export { default as Card } from '@bit/xseed.ui-components.card';
export { default as Container } from '@bit/xseed.ui-components.container';
export { default as Input } from '@bit/xseed.ui-components.input';
export { default as Loader } from '@bit/xseed.ui-components.loader';
export { default as Modal } from '@bit/xseed.ui-components.modal';
export { default as Select } from '@bit/xseed.ui-components.select';
export { default as Switch } from '@bit/xseed.ui-components.switch';

export const OptionGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px !important;

  > * + * {
    margin-left: 20px;
  }
`;

export const OptionItem = styled.button`
  cursor: pointer;
  border-radius: 999px;
  font-size: 18px !important;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px !important;
  background-color: var(--text-color-2);
  color: #fff;
  font-weight: normal;
  flex: 1;

  &:hover {
    background-color: var(--text-color-1);
  }

  ${props =>
    props.active &&
    `
    background-color: var(--blue-color) !important;
  `}

  img {
    max-height: 32px;
    height: auto;
    margin-right: 16px !important;
  }

  ${props =>
    props.small &&
    `
    padding: 10px 20px !important;
    font-size: 16px !important;

    img {
      max-height: 24px;
      margin-right: 8px !important;
    }
  `}
`;
